import placeholderImage from 'assets/placeholderImage.png'
import { IComparison, IProductData } from 'types/comparison'

export const MAX_COMPARISON_PROPERTIES_COUNT = 10

export const initialComparedProduct = { id: '', shortName: '', sku: '', packshotUrl: placeholderImage }

export const emptyComparison = {
  paramNames: [''],
  comparedProducts: [
    {
      product: '',
      paramValues: ['']
    }
  ]
}

export const getDefaultComparison = (product: IProductData): IComparison => {  
  return  {
    paramNames: [''],
    comparedProducts: [
      {
        product: {
          id: product.id,
          name: product.name,
          shortName: product.shortName,
          sku: product.sku,
          packshotUrl: product.packshotUrl || placeholderImage,
          packshotAlt: product.packshotAlt || '',
          isCurrent: true
        },
        paramValues: ['']
      },
      {
        product: initialComparedProduct,
        paramValues: ['']
      },
      {
        product: initialComparedProduct,
        paramValues: ['']
      },
      {
        product: initialComparedProduct,
        paramValues: ['']
      },
      {
        product: initialComparedProduct,
        paramValues: ['']
      }
    ]
  }
}

export const hasDuplicates = (stringArray: string[]) => {
  return stringArray.length !== new Set(stringArray).size;
};